export enum WORKER_STATUSES {
  error = 'Error',
  pending = 'Pending',
  success = 'Success',
  onHold = 'Holding',
}
